<i18n src="@/locales/models/package_planning.yml" lang="yaml"></i18n>
<template>
  <div v-if="render">
    <div v-for="(package_planning, index) in package_plannings" :key="index">
      <div
        class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12"
        v-show="!package_planning._destroy"
      >
        <div class="sm:col-span-3">
          <label :class="['label-form', isInvalidLabel('num_packages')]">
            {{ $t("model.package_planning.num_packages") }}
          </label>
          <div class="mt-1">
            <input
              type="text"
              v-model.number="package_planning.num_packages"
              :class="['input-text', isInvalid('num_packages')]"
            />
          </div>
        </div>
        <div class="sm:col-span-4">
          <label class="label-form">
            {{ $t("model.package_planning.agro_exporter_brand_id") }}
          </label>
          <div class="mt-1">
            <select-form
              v-if="brands.length > 0"
              :options="brands"
              :clearable="false"
              v-model="package_planning.agro_exporter_brand_id"
            />
          </div>
        </div>
        <div class="sm:col-span-4">
          <label class="label-form">
            {{ $t("model.package_planning.size_package_plannings") }}
          </label>
          <div class="mt-1">
            <select-form
              v-if="sizes.length > 0"
              :options="sizes"
              :multiple="true"
              v-model="package_planning.crop_size_ids"
            />
          </div>
        </div>
        <div class="sm:col-span-1">
          <label class="label-form"></label>
          <div class="mt-8">
            <button
              class="p-2 flex items-start md:items-center mt-4 md:mt-1"
              v-if="!only_package_plannings"
              @click.prevent="removePackagePlanning(index)"
            >
              <i :class="['fa-solid fa-lg pl-1 text-blue-700', 'fa-minus']"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
      <div class="sm:col-span-3"></div>
      <div class="sm:col-span-4"></div>
      <div class="sm:col-span-4"></div>
      <div class="sm:col-span-1">
        <button
          class="p-2 flex items-start md:items-center mt-4 md:mt-1 text-right"
          @click.prevent="newPackagePlanning"
        >
          <i :class="['fa-solid fa-lg pl-1 text-blue-700', 'fa-plus']"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      package_plannings: this.modelValue,
      render: false,
    };
  },
  props: {
    modelValue: {
      type: Array,
      default: () => {
        [];
      },
    },
    brands: { type: Array },
    sizes: { type: Array },
    default_agro_exporter_brand_id: { default: null }
  },
  computed: {
    not_destroyed_package_plannings: function () {
      return this.package_plannings.filter(
        (package_planning) => !package_planning._destroy
      );
    },
    only_package_plannings: function () {
      return this.not_destroyed_package_plannings.length == 1;
    },
  },
  watch: {
    package_plannings: function (newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
  methods: {
    newPackagePlanning: function () {
      let empty_planning = {
        id: null,
        num_packages: null,
        agro_exporter_brand_id: this.default_agro_exporter_brand_id, // agrega por defecto el primer brand, para asegurar la validación del FK
        crop_size_ids: [],
        _destroy: false,
      };
      this.package_plannings.push(empty_planning);
    },
    removePackagePlanning: function (index) {
      const package_planning = this.package_plannings[index];
      if (!package_planning) return;
      if (package_planning.id) {
        package_planning._destroy = true;
      } else {
        this.package_plannings.splice(index, 1);
      }
      if (this.package_plannings.length == 0) this.newPackagePlanning();
    },
  },
  created() {
    if (this.package_plannings.length == 0) this.newPackagePlanning();
    this.render = true;
  },
};
</script>